import { HEADERS } from ".";

export const RESEARCHPROJECTS_API = {
  getAllResearchProjectList: () => ({
    endPoint: `/api/v1/project/list`,
    headers: HEADERS.TOKEN_HEADER,
    method: "GET",
  }),
  getResearchProjectByProfileId: (id) => ({
    endPoint: `/api/v1/project/profile/${id}`,
    headers: HEADERS.TOKEN_HEADER,
    method: "GET",
  }),
  insertResearchProject: () => ({
    endPoint: "/api/v1/project/create",
    headers: HEADERS.TOKEN_HEADER,
    method: "POST",
  }),
  updateResearchProject: () => ({
    endPoint: "/api/v1/project/update",
    headers: HEADERS.TOKEN_HEADER,
    method: "PUT",
  }),
  deleteResearchProject: (id) => ({
    endPoint: `/api/v1/project/${id}`,
    headers: HEADERS.TOKEN_HEADER,
    method: "DELETE",
  }),
  updateResearchProjectAccepted: () => ({
    endPoint: "/api/v1/formResearch/updateScore_Accepted",
    headers: HEADERS.TOKEN_HEADER,
    method: "PUT",
  }),
  // Nối 1 liên kết vào hồ sơ ngay khi Thêm - không cần bấm Lưu bản nháp.
  linkResearchProjectToForm: () => ({
    endPoint: "/api/v1/formResearch/addOne",
    headers: HEADERS.TOKEN_HEADER,
    method: "POST",
  }),
};

export const RESEARCHPROJECTS_TYPE = {
  GET_ALL_RESEARCH_PROJECT_LOADING: "GET_ALL_RESEARCH_PROJECT_LOADING",
  GET_ALL_RESEARCH_PROJECT_SUCCESS: "GET_ALL_RESEARCH_PROJECT_SUCCESS",
  GET_ALL_RESEARCH_PROJECT_FAILURE: "GET_ALL_RESEARCH_PROJECT_FAILURE",

  GET_RESEARCH_PROJECT_BY_PROFILE_ID_LOADING: "GET_RESEARCH_PROJECT_BY_PROFILE_ID_LOADING",
  GET_RESEARCH_PROJECT_BY_PROFILE_ID_SUCCESS: "GET_RESEARCH_PROJECT_BY_PROFILE_ID_SUCCESS",
  GET_RESEARCH_PROJECT_BY_PROFILE_ID_FAILURE: "GET_RESEARCH_PROJECT_BY_PROFILE_ID_FAILURE",

  INSERT_RESEARCHPROJECT_LOADING: "INSERT_RESEARCHPROJECT_LOADING",
  INSERT_RESEARCHPROJECT_SUCCESS: "INSERT_RESEARCHPROJECT_SUCCESS",
  INSERT_RESEARCHPROJECT_FAILURE: "INSERT_RESEARCHPROJECT_FAILURE",

  UPDATE_RESEARCHPROJECT_LOADING: "UPDATE_RESEARCHPROJECT_LOADING",
  UPDATE_RESEARCHPROJECT_SUCCESS: "UPDATE_RESEARCHPROJECT_SUCCESS",
  UPDATE_RESEARCHPROJECT_FAILURE: "UPDATE_RESEARCHPROJECT_FAILURE",

  DELETE_RESEARCHPROJECT_LOADING: "DELETE_RESEARCHPROJECT_LOADING",
  DELETE_RESEARCHPROJECT_SUCCESS: "DELETE_RESEARCHPROJECT_SUCCESS",
  DELETE_RESEARCHPROJECT_FAILURE: "DELETE_RESEARCHPROJECT_FAILURE",

  UPDATE_RESEARCHPROJECT_ACCEPTED_LOADING: "UPDATE_RESEARCHPROJECT_ACCEPTED_LOADING",
  UPDATE_RESEARCHPROJECT_ACCEPTED_SUCCESS: "UPDATE_RESEARCHPROJECT_ACCEPTED_SUCCESS",
  UPDATE_RESEARCHPROJECT_ACCEPTED_FAILURE: "UPDATE_RESEARCHPROJECT_ACCEPTED_FAILURE",
};

export const RESEARCHPROJECTS_CONSTANTS = {
  // QCV 2026 (bảng điểm mục 4): Vai trò Chủ trì/Đồng chủ trì; cấp Nhà nước/Bộ/Hợp tác QT.
  TYPO_OPTIONS: [
    { key: "d1", title: "Chủ trì", value: "d1" },
    { key: "d2", title: "Đồng chủ trì", value: "d2" },
  ],
  LEVEL_OPTIONS: [
    { key: "domestic", title: "Đề tài cấp Nhà nước và tương đương đã nghiệm thu", value: "domestic" },
    { key: "ministry", title: "Đề tài cấp Bộ và tương đương đã nghiệm thu", value: "ministry" },
    // Giữ lại (không dùng để chọn mới) - hồ sơ cũ trước "QCV 2026" còn lưu
    // giá trị này, thiếu trong danh sách sẽ làm cột Phân loại hiện trắng dù
    // DB vẫn có dữ liệu. Không ảnh hưởng dropdown thêm mới vì DuAnForm ưu
    // tiên getQcvScoreOptions (mục 4) khi season có cấu hình.
    { key: "school", title: "Đề tài cấp Cơ sở đã nghiệm thu", value: "school" },
  ],
};
